

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey =
    import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl) {
    throw new Error(
        '[Supabase] Missing VITE_SUPABASE_URL in .env.local',
    )
}

if (!supabaseAnonKey) {
    throw new Error(
        '[Supabase] Missing VITE_SUPABASE_ANON_KEY in .env.local',
    )
}

const supabase = createClient(
    supabaseUrl,
    supabaseAnonKey,
)

export default supabase